
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/emergency-plumbing-service",
      function () {
        return require("private-next-pages/services/emergency-plumbing-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/emergency-plumbing-service"])
      });
    }
  